import { MouseEvent } from 'react';

import { Card, CardBody, Flex, Text } from '@backstage/ui';

import { AttachmentFragment } from '@spotify/confidence-graphql';

import { useArtifactDisplay } from '../../hooks/useArtifactDisplay';
import { ArtifactActionsMenu } from '../ArtifactActionsMenu';
import { ArtifactIcon } from '../ArtifactIcon';
import styles from './ArtifactCardBase.module.css';

const stopPropagation = (e: MouseEvent) => e.stopPropagation();

interface ArtifactCardBaseProps {
  artifact: AttachmentFragment;
  resolvedDisplayName?: string;
  onNavigate: () => void;
  onDelete?: () => void;
}

export const ArtifactCardBase = ({
  artifact,
  resolvedDisplayName,
  onNavigate,
  onDelete,
}: ArtifactCardBaseProps) => {
  const { Icon, typeLabel, displayName } = useArtifactDisplay(
    artifact,
    resolvedDisplayName,
  );

  return (
    <button type="button" className={styles.cardButton} onClick={onNavigate}>
      <Card className={styles.card}>
        <CardBody>
          <Flex align="center" gap="2">
            <ArtifactIcon>
              <Icon size={16} />
            </ArtifactIcon>
            <Flex className={styles.info} direction="column" gap="0">
              <Text variant="body-medium" weight="bold" truncate>
                {displayName}
              </Text>
              <Text variant="body-small" color="secondary" truncate>
                {typeLabel}
              </Text>
            </Flex>
            {onDelete && (
              <span
                role="toolbar"
                className={styles.menuButton}
                onClick={stopPropagation}
                onKeyDown={e => e.stopPropagation()}
              >
                <ArtifactActionsMenu
                  artifact={artifact}
                  resolvedDisplayName={resolvedDisplayName}
                  onDelete={onDelete}
                />
              </span>
            )}
          </Flex>
        </CardBody>
      </Card>
    </button>
  );
};
